import { httpApi } from "api/http.api";

export const getOrderOverview = (): Promise<any[]> =>
  httpApi.get<any[]>("OrderView/Clients").then(({ data }) => data);

export const getOrderByCompany = (): Promise<any[]> =>
  httpApi.get<any[]>("OrderView/Garments").then(({ data }) => data);

export const getOpenOrderProfessionals = (data: any=null): Promise<any[]> => { 
  return httpApi.get<any[]>(`OrderView/OpenOrderProfessionals/${data}`).then((data:any) => data.data.data);

}


export const getOrderByProfessional = (data: any): Promise<any[]> => {  
  return httpApi.get<any[]>(`OrderView/GarmentsOfProfessional2/${data.client_id}/${data.professional_id}`).then(({ data }) => data);
}

export const getAffiliationsOfGarment = (data: any): Promise<any[]> => { 
  return httpApi.get<any[]>(`/OrderView/AffiliationsOfGarment2/${data.client_id}/${data.professional_id}/${data.garment_id}/${data.order_id}`).then(({ data }) => data);
}

export const getCompanyOrderData = (clientIds: any): Promise<any[]> => { 
  return httpApi.get<any[]>(`OrderView/Garments/${clientIds}`).then((data:any) => data?.data?.data);
}


 
export const postReadyForAffiliation = (data: any): Promise<any[]> => { 
  return httpApi.post<any[]>(`Affiliations/ChangeAffiliationOrderStatusToReady`,data).then(({ data }) => data);
}
 
 
export const printAfflication = (data: any): Promise<any[]> => { 
  return httpApi.post<any[]>(`OrderView/ExportBarcodes2/`,data).then(({ data }) => data);
}